export default __webpack_public_path__ + "static/media/about.de1054b9.jpeg";